define('modules/start/dashboard/contactsDb/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                "email_users": this.productsReport.get("email_users"),
                "sms_users": this.productsReport.get("sms_users"),
                "cookies_users": this.productsReport.get("cookies_users"),
                "email_users_7days_evolution": this.productsReport.getEmailProgressionLast7days(),
                "email_users_30days_evolution": this.productsReport.getEmailProgressionLast30days(),
                "sms_users_7days_evolution": this.productsReport.getSMSProgressionLast7days(),
                "sms_users_30days_evolution": this.productsReport.getSMSProgressionLast30days(),
                "cookies_users_7days_evolution": this.productsReport.getCookiesProgressionLast7days(),
                "cookies_users_30days_evolution": this.productsReport.getCookiesProgressionLast30days()
            };
        }
    });

    module.exports = Layout;
});

